import { TESTER_IMG } from "./build";

// Locked hardware: 4 continuous probes + 3 top-loaded 6 mm strip slots. No liquid reagents.
export const SHOP_IMG = {
  hero: TESTER_IMG.front,
  angle: TESTER_IMG.rear,
};

export const SHOP_SPECS = [
  { k: "Footprint", v: "Benchtop · ~260 × 300 × 240 mm" },
  { k: "Probes", v: "4 continuous · FC · pH · Salt/TDS · Temp" },
  { k: "Strips", v: "3 top slots · 6-in-1 · Phosphate · Magnesium" },
  { k: "Detection", v: "Smart 1–3 strip sensing + prompt LEDs" },
  { k: "Full panel", v: "~60–90 s (probe + strip develop)" },
  { k: "Reagents", v: "None — no liquids or cartridges" },
  { k: "Self-clean", v: "Flood-&-overflow basin rinse between tests" },
  { k: "Output", v: "Syncs to Pool Software · branded report" },
];

// The self-cleaning operator workflow (accurate to the locked hardware)
export const SHOP_STEPS = [
  { t: "Guided strip prompt", d: "The unit reads the client's stored pool profile and lights which of the three slots to load — 6-in-1 always, plus Phosphate and/or Magnesium only when the pool needs them." },
  { t: "Drop the strips", d: "Push each lit 6 mm strip straight down into its top slot. Strip-present sensors confirm exactly which strips are loaded — 1, 2 or all 3." },
  { t: "Pour the sample", d: "Tip the customer's beaker into the smooth spill-proof basin. The tank fills until the four probes and the strip pads sit submerged; over-pours just drain back through the centre hole." },
  { t: "Probes + strips read", d: "The four probes read continuously while the optical readers watch each strip develop — the full panel lands in about 60–90 seconds." },
  { t: "Flood self-clean", d: "The sample drains, then the pump floods fresh rinse water up until it overflows the basin into a hidden perimeter gutter to waste — cleaning the tank AND the pour basin, with no lid, wiping or moving parts." },
  { t: "Sync & report", d: "Results push over USB-C / Bluetooth to the Pool Software, ready as a white-label printable report the customer can take home." },
];

// Honest comparison vs LaMotte WaterLink Spin Touch (disk)
export const SHOP_COMPARE = [
  { row: "Full-panel time", ours: "~60–90 s", disk: "~60 s", win: false },
  { row: "Cost per test", ours: "One low-cost 6-in-1 strip — or none", disk: "~$3–5 per disk", win: true },
  { row: "Consumables", ours: "6 mm strips · no disks or cartridges", disk: "Single-use disk every test", win: true },
  { row: "Reagents", ours: "None — no liquid reagents", disk: "Reagents sealed in the disk", win: true },
  { row: "Continuous probes", ours: "FC · pH · Salt/TDS · Temp (live)", disk: "None — all reagent", win: true },
  { row: "Parameters", ours: "4 probes + 6-in-1, +Phosphate, +Magnesium", disk: "Up to ~10", win: null },
  { row: "Self-cleaning", ours: "Flood-&-overflow auto rinse", disk: "n/a — disk discarded", win: null },
  { row: "Portable / field use", ours: "Portable variant · battery", disk: "Benchtop only", win: true },
  { row: "Output", ours: "Syncs to Pool Software + branded report", disk: "Brand's own software", win: null },
];

export const POOL_TYPES = [
  { key: "pool", label: "Swimming pool" },
  { key: "spa", label: "Spa / hot tub" },
];
export const SANITISERS = [
  { key: "salt", label: "Salt / chlorinator" },
  { key: "liquid", label: "Liquid / granular chlorine" },
];
export const SURFACES = [
  { key: "concrete", label: "Concrete / pebble" },
  { key: "fibreglass", label: "Fibreglass" },
  { key: "vinyl", label: "Vinyl liner" },
];
